import axiosInstance from "../lib/axiosInstance";

class giftcardModel {
  constructor() {
    this.base_url = "/giftcard";
    this.base_url2 = "/giftcard-product";
    this.base_url3="/reports/giftcard"
  }
  async list(query = []) {
    return (
      await axiosInstance.get(`${this.base_url}?${new URLSearchParams(query)}`)
    ).data;
  }
  async create(data = []) {
    return await axiosInstance.post(this.base_url2, data);
  }
  async update(id, data = []) {
    return await axiosInstance.post(
      `${this.base_url2}/${id}?_method=PUT`,
      data
    );
  }
  async destroy(id, data = []) {
    return await axiosInstance.delete(`${this.base_url}/${id}`, data);
  }
  async show(id, data = []) {
    return await axiosInstance.get(`${this.base_url2}/${id}`, data);
  }
  async Giftcardlist(query = []) {
    return (
      await axiosInstance.get(`${this.base_url2}?${new URLSearchParams(query)}`)
    ).data;
  }
  async ExportGiftcard(data = []) {
    return await axiosInstance.post(`${this.base_url3}`, data);
  }
}

export default new giftcardModel();
